const { createGlobalStyle } = require("styled-components");

export const GlobalStyle = createGlobalStyle`
    html, body {
        padding: 0;
        margin: 0;
    }

    #studievælger-root {
        font-family: sans-serif;
        * {
            box-sizing: border-box;
        }
        button {
            cursor: pointer;
        }
    }

    .ReactModal__Overlay {
        opacity: 0;
        transition: opacity 250ms ease;
    }

    .ReactModal__Overlay--after-open{
        opacity: 1;
    }

    .ReactModal__Overlay--before-close{
        opacity: 0;
    }
    .test {
        color: blue;
    }

    ${({ styling }) => styling}

`;
